import React, { useState, useEffect } from "react";
import { useHistory, useLocation } from "react-router-dom";

import { Typography, Box } from "@mui/material";

import MaterialTable from "@material-table/core";

import AddCircleIcon from "@mui/icons-material/AddCircle";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";

import { useSnackbar } from "notistack";
import { apiGet, API } from "@services/API";

import UserAddEditDialog from "@components/UserAddEditDialog";
import ConfirmDialog from "@components/ConfirmDialog";

function headers() {
  let headers = {};

  let token = localStorage.getItem("covid19_token");
  let mfa_token = localStorage.getItem("mfa_token");

  if (token && token.length > 0 && mfa_token && mfa_token.length > 0) {
    headers = { "x-access-token": token };
  }
  return headers;
}

export default function Users({ ...props }) {
  const history = useHistory();

  const level = parseInt(localStorage.getItem("user_level"), 10);
  const hospitalID = localStorage.getItem("hospital_id");

  const { enqueueSnackbar, closeSnackbar } = useSnackbar();

  const [data, setData] = useState([]);
  const [dataHospitals, setDataHospitals] = useState([]);
  const [dataAccessLevels, setDataAccessLevels] = useState([]);

  const [loading, setLoading] = useState(true);
  const [pageSize, setPageSize] = useState(10);
  const [rowsPerPage, setRowsPerPage] = useState([5, 10, 25, 50, 75, 100]);

  const [isAddEditUserDialogVisible, setIsAddEditUserDialogVisible] =
    useState(false);
  const [selectedUser, setSelectedUser] = useState(null);

  const [isConfirmUserDeleteVisible, setIsConfirmUserDeleteVisible] =
    useState(false);

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = () => {
    const timeOut = setTimeout(() => {
      setIsAddEditUserDialogVisible(false);
      setLoading(true);

      apiGet(`/accessLevels`, { headers: headers() }, history)
        .then((response) => {
          if (level === 5 || level === 6) {
            const filteredData = response.data.accessLevels.filter(
              (item) => item.level_id > 3
            );
            setDataAccessLevels(filteredData);
          } else {
            setDataAccessLevels(response.data.accessLevels);
          }
        })
        .catch((error) => {
          setDataAccessLevels([]);
        });

      apiGet(`/hospitals`, { headers: headers() }, history)
        .then((response) => {
          if (level === 5 || level === 6) {
            const filteredData = response.data
              .filter((item) => Number(item.id) === Number(hospitalID))
              .map((item) => ({
                id: item.id,
                name: item.name,
              }));

            setDataHospitals(filteredData);
          } else {
            const filteredData = response.data.map((item) => ({
              id: item.id,
              name: item.name,
            }));

            setDataHospitals(filteredData);
          }
        })
        .catch((error) => {
          setDataHospitals([]);
        });

      apiGet("/users", { headers: headers() }, history)
        .then((response) => {
          if (level === 1 || level === 2 || level === 3) {
            setData(response.data.users);
          } else if (level === 5 || level === 6) {
            const filteredData = response.data.users.filter(
              (item) =>
                Number(item.hospital_id) === Number(hospitalID) &&
                item.level_id > 3
            );
            setData(filteredData);
          } else {
            setData([]);
          }
          setLoading(false);
        })
        .catch((error) => {
          setLoading(false);
          showSnackBar("error", "Failure", "Failed to retrieve data.");
        });
    }, 200);

    return () => clearTimeout(timeOut);
  };

  const showSnackBar = (type, title, subtitle) => {
    const options = { variant: type };

    enqueueSnackbar(
      <div style={{ display: "inline-grid" }}>
        <Typography data-test={"snack-title"} variant="h6">
          {title}
        </Typography>
        <Typography data-test={"snack-text"} variant="subtitle1">
          {subtitle}
        </Typography>
      </div>,
      options
    );
  };

  const isNullOrEmpty = (value) => {
    if (value === null || value === undefined) {
      return true;
    }

    if (typeof value === "string" && value.trim().toLowerCase() === "null") {
      return true;
    }

    if (Array.isArray(value) && value.length === 0) {
      return true;
    }

    if (typeof value === "string" && value.trim() === "") {
      return true;
    }

    if (typeof value === "number" && isNaN(value)) {
      return true;
    }

    return false;
  };

  const handleChangePage = (event) => {
    //event.target.value === 'All' ? setRowsPerPage(data.length) : setRowsPerPage(event.target.value);
  };

  const handleChangeRowsPerPage = (event) => {
    setPageSize(event);
  };

  const getHospitalNameDropdown = () => {
    const options = {};

    if (!isNullOrEmpty(dataHospitals)) {
      dataHospitals
        .sort((a, b) => (a.name > b.name ? 1 : -1))
        .map((e) => {
          const { name, id } = e;
          options[id] = name;
        });
    }
    return options;
  };

  const getAccessLevelNameDropdown = () => {
    const options = {};

    if (!isNullOrEmpty(dataAccessLevels)) {
      dataAccessLevels
        //.sort((a, b) => (a.name > b.name ? 1 : -1))
        .map((e) => {
          const { level_description, level_id } = e;
          options[level_id] = level_description;
        });
    }

    return options;
  };

  const handleAddEditUser = (userDetails) => {
    setSelectedUser(userDetails);
    setIsAddEditUserDialogVisible(true);
  };

  const handleDeleteUser = (userDetails) => {
    showSnackBar("Failure", "Delete user feature unavailable.");
    // setSelectedUser(userDetails);
    // setIsConfirmUserDeleteVisible(true);
  };

  const handelCloseUser = () => {
    setIsAddEditUserDialogVisible(false);
    setSelectedUser(null);
  };

  const handelSaveUser = () => {
    setIsAddEditUserDialogVisible(false);
    setSelectedUser(null);
    fetchData();
  };

  const deleteUser = () => {
    const userBody = {
      UserId: selectedUser.user_id,
    };

    API.post("/deleteUser", userBody, {
      headers: headers(),
    })
      .then((response) => {
        showSnackBar("success", "Success", "User successfully deleted.");
        fetchData();
      })
      .catch((error) => {
        showSnackBar("error", "Failure", "Failed to delete user.");
      });
  };

  return (
    <Box style={{ margin: 10 }} data-test={"users-list"}>
      <MaterialTable
        style={{}}
        title="Users"
        columns={[
          {
            title: "Firstname",
            field: "firstname",
          },
          {
            title: "Surname",
            field: "surname",
          },
          {
            title: "Email",
            field: "username",
          },
          {
            title: "Portal Password",
            field: "password",
            render: (rowData) => {
              if (isNullOrEmpty(rowData.password)) {
                return <Typography></Typography>;
              } else {
                return (
                  <Typography>{"*".repeat(rowData.password.length)}</Typography>
                );
              }
            },
          },
          {
            title: "Tablet Pin",
            field: "tablet_pin",
            render: (rowData) => {
              if (isNullOrEmpty(rowData.tablet_pin)) {
                return <Typography></Typography>;
              } else {
                return (
                  <Typography>
                    {"*".repeat(rowData.tablet_pin.length)}
                  </Typography>
                );
              }
            },
          },
          {
            title: "Hospital",
            field: "hospital_id",
            lookup: getHospitalNameDropdown(),
            initialEditValue: "",
            render: (rowData) => {
              if (
                rowData.level_id == 1 ||
                rowData.level_id == 2 ||
                rowData.level_id == 3
              ) {
                return "All";
              } else {
                return getHospitalNameDropdown()[rowData.hospital_id];
              }
            },
          },
          {
            title: "Authorization Level",
            field: "level_id",
            lookup: getAccessLevelNameDropdown(),
            initialEditValue: "",
            width: "30%",
          },
        ]}
        data={data}
        options={{
          padding: "dense",
          addRowPosition: "first",
          exportAllData: true,
          filtering: false,
          pageSize: pageSize,
          pageSizeOptions: rowsPerPage,
          loadingType: "overlay",
          tableLayout: "auto",
          //minBodyHeight: "75vh",
          //maxBodyHeight: "75vh",
          headerStyle: {
            position: "sticky",
            top: 0,
            backgroundColor: "#fff",
            zIndex: "1",
          },
        }}
        editable={
          {
            //isEditable: rowData => rowData.name === 'a', // only name(a) rows would be editable
            //isEditHidden: (rowData) => rowData.title === 'Acorn Group',
            //isDeletable: rowData => rowData.name === 'b', // only name(b) rows would be deletable,
            //isDeleteHidden: (rowData) => rowData.title === 'Acorn Group',
            // onRowAdd: (newData) =>
            //   new Promise((resolve, reject) => {
            //     handleRowAdd(newData, resolve, reject);
            //   }),
            // onRowUpdate: (newData, oldData) =>
            //   new Promise((resolve, reject) => {
            //     handleRowUpdate(newData, oldData, resolve, reject);
            //   }),
            // onRowDelete: (oldData) =>
            //   new Promise((resolve, reject) => {
            //     handleRowDelete(oldData, resolve, reject);
            //   }),
          }
        }
        actions={[
          {
            icon: (props) => (
              <AddCircleIcon
                {...props}
                color="primary"
                data-test="users-add-user-btn"
              />
            ),
            tooltip: "Add User",
            isFreeAction: true,
            //hidden: level == 7 || level == 8 ? true : false,
            onClick: (event, rowData) => handleAddEditUser(null),
          },
          {
            icon: (props) => <EditIcon {...props} color="primary" />,
            tooltip: "Edit User",
            onClick: (event, rowData) => handleAddEditUser(rowData),
          },
          {
            icon: (props) => <DeleteIcon {...props} color="red" />,
            tooltip: "Delete User",
            onClick: (event, rowData) => handleDeleteUser(rowData),
          },
        ]}
        isLoading={loading}
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage}
      />

      {isAddEditUserDialogVisible && (
        <UserAddEditDialog
          isVisible={isAddEditUserDialogVisible}
          onClose={handelCloseUser}
          onSave={handelSaveUser}
          dataHospitals={dataHospitals}
          dataAccessLevels={dataAccessLevels}
          dataUser={selectedUser}
        />
      )}

      {isConfirmUserDeleteVisible && (
        <ConfirmDialog
          title="Confirm"
          open={isConfirmUserDeleteVisible}
          setOpen={setIsConfirmUserDeleteVisible}
          onConfirm={deleteUser}
          onCancel={() => {
            setIsConfirmUserDeleteVisible(false);
          }}
        >
          Are you sure you want to permanently delete this user ?
        </ConfirmDialog>
      )}
    </Box>
  );
}
